import { IdentitySyncOperationType } from '@/ws';

const IDENTITY_SYNC_FAILED_MESSAGES: Record<IdentitySyncOperationType, string> = {
  [IdentitySyncOperationType.EmployeeModified]:
    "We couldn't sync these employee changes. The update has been reverted.",
  [IdentitySyncOperationType.EmployeeEnabled]: "We couldn't sync enabling this employee. The change has been reverted.",
  [IdentitySyncOperationType.EmployeeDisabled]:
    "We couldn't sync disabling this employee. The change has been reverted.",
  [IdentitySyncOperationType.CustomerModified]:
    "We couldn't sync these customer changes. The update has been reverted.",
  [IdentitySyncOperationType.CustomerEnabled]: "We couldn't sync enabling this customer. The change has been reverted.",
  [IdentitySyncOperationType.CustomerDisabled]:
    "We couldn't sync disabling this customer. The change has been reverted.",
  [IdentitySyncOperationType.OpoUserDataUpdated]: "We couldn't sync this email update. The change has been reverted.",
};

const DEFAULT_IDENTITY_SYNC_FAILED_MESSAGE = "We couldn't sync your recent change. The update has been reverted.";

export const getIdentitySyncFailedMessage = (operationType: IdentitySyncOperationType): string =>
  IDENTITY_SYNC_FAILED_MESSAGES[operationType] ?? DEFAULT_IDENTITY_SYNC_FAILED_MESSAGE;
